import React from "react";
import { useSelector } from "react-redux";
import { Box } from "@material-ui/core";

// Styles
import useStyles from "./styles";
import clsx from "clsx";

const NoDataFound = ({
  title = "contacts",
  subTitle = "No data available for this page at the moment",
  wrapperClass,
}) => {
  const { isDarkMode } = useSelector((state) => state.theme);
  const styles = useStyles({ isDarkMode });

  return (
    <Box className={styles.flexCenter}>
      <Box
        className={clsx(styles.container, { [wrapperClass]: !!wrapperClass })}
      >
        <span>{subTitle}</span>
        <h4>{title}</h4>
      </Box>
    </Box>
  );
};

export default NoDataFound;
